import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, from, map, tap } from 'rxjs';
import * as z from 'zod';

import { HistoryRecord } from '../schemas';
import { Lambda } from './lambda';

@Injectable({ providedIn: 'root' })
export class HistoryRecordService {
  private history: Record<string, HistoryRecord[]> = {};
  private http = inject(HttpClient);
  private url = inject(Lambda).getRecordsUrl();

  getHistory(id: string, force = false, limit = 0): Observable<HistoryRecord[]> {
    if (force) {
      delete this.history[id];
    }
    if (id in this.history) {
      return from([this.history[id].slice(0, limit || undefined)]);
    }

    return this.fetchHistory(id).pipe(map((history: HistoryRecord[]) => history.slice(0, limit || undefined)));
  }

  private fetchHistory(id: string): Observable<HistoryRecord[]> {
    const request = this.http.get<HistoryRecord[]>([this.url, id].join('/'), {}).pipe(
      map((data) => z.array(HistoryRecord).parse(data)),
      tap((data) => (this.history[id] = data)),
    );

    return request;
  }
}
